import { getEnv } from "@bkry/bowline-utils";
import PropTypes from "prop-types";
import React from "react";
import { useRegisterEffect, useSsrEffect } from "@issr/core";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";
import {
  getRoadmapAttributesBySlug,
  getRoadmapRelationships,
  showRoadmap,
} from "@bkry/bowline-redux/roadmaps";
import RoadmapMilestone from "./utils/RoadmapMilestone";

/**
 * TODO: This component is rendered both on public and creator app
 * through the page builder. It wont be server rendered since the
 * modules dont support SSR and we cant use the useSsrEffect hook
 **/
const Roadmap = ({ roadmapSlug, noDispatch }) => {
  const REACT_APP_PROJECT_ID = getEnv("REACT_APP_PROJECT_ID");
  const { projectId } = useParams();
  const dispatch = useDispatch();
  const registerEffect = useRegisterEffect();
  const lang = useSelector((state) => state.i18nState.lang);

  const dispatchApi = async () => {
    if (!roadmapSlug || noDispatch) return;
    registerEffect(
      dispatch,
      showRoadmap({
        // projectId is used in creator and REACT_APP_PROJECT_ID is for public apps
        projectId: projectId || REACT_APP_PROJECT_ID,
        slug: roadmapSlug,
      })
    );
  };

  useSsrEffect(dispatchApi, [dispatch, roadmapSlug, lang]);

  const roadmapData = useSelector((state) =>
    getRoadmapAttributesBySlug(state, roadmapSlug)
  );

  const roadmapRelationships = useSelector((state) =>
    getRoadmapRelationships(state, roadmapData?.id)
  );

  if (!roadmapData) return null;

  return (
    <div
      // the style is currently not being sent by api
      style={
        roadmapData.backgroundImagePath && {
          backgroundImage: `url('${roadmapData.backgroundImagePath}')`,
          backgroundPosition: "right center",
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
        }
      }
      className="bigger-margin-top bigger-margin-bottom roadmap"
    >
      <Container>
        <Row className="text-center justify-content-center">
          <Col xs={12} lg={8} className="text-center">
            {roadmapData.title && <h2>{roadmapData.title}</h2>}
            {roadmapData.intro && (
              <div
                className="text-center"
                dangerouslySetInnerHTML={{
                  __html: roadmapData.intro.replace(
                    /href="http/g,
                    ` target='_blank' rel='noopener noreferrer' href="http`
                  ),
                }}
              />
            )}
          </Col>
        </Row>
        {!!roadmapRelationships?.milestones?.data?.length && (
          <div className="roadmap__wrapper pt-5 pt-lg-0">
            <div className="roadmap__step d-none d-lg-block">
              <div
                className="message message--right"
                style={{ height: "10rem" }}
              />
            </div>
            {roadmapRelationships?.milestones?.data?.map((milestone, i) => (
              <RoadmapMilestone
                milestoneId={milestone.id}
                index={i}
                key={milestone.id}
              />
            ))}
          </div>
        )}
        <div className="d-flex justify-content-center ">
          <p className="small fw-lighter mb-2 wagmi">WAGMI</p>
        </div>
        {roadmapData.outro && (
          <Row className="text-center justify-content-center">
            <Col xs={12} lg={8} className="text-center">
              <div
                className="mb-3"
                dangerouslySetInnerHTML={{
                  __html: roadmapData.outro.replace(
                    /href="http/g,
                    ` target='_blank' rel='noopener noreferrer' href="http`
                  ),
                }}
              />
            </Col>
          </Row>
        )}
      </Container>
    </div>
  );
};

Roadmap.propTypes = {
  roadmapSlug: PropTypes.string.isRequired,
  noDispatch: PropTypes.bool,
};

Roadmap.defaultProps = {
  noDispatch: false,
};

export default Roadmap;
